import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Select from "react-select";
import * as codeActions from "../../actions/codeActions";
import * as loaderActions from "../../actions/loaderActions";

const CallTypeSelect = ({
  value: initialValue,
  isMulti = false,
  onChange,
  codes = [],
  actions,
  loading,
  placeholder,
  label,
  disabled
}) => {
  const fetchCodes = useCallback(async () => {
    await actions.loadCodes();
    await actions.toggleLoader(false);
  }, [actions]);
  useEffect(() => {
    if (!codes.length && !loading) {
      actions.toggleLoader(true);
      fetchCodes();
    }
  });

  const options = codes
    .filter((code) => code.entity === "Call" && code.field === "type")
    .map((d) => ({
      label: d.value,
      value: d._id
    }));

  const value =
    isMulti && Array.isArray(initialValue)
      ? options.filter((x) =>
          initialValue.find((i) => i.value === x.value || i === x.value)
        )
      : initialValue;
  return (
    <React.Fragment>
      {label ? (
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor="call-type-select"
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </label>
      ) : null}
      <Select
        name="call-type-select"
        id="call-type-select"
        className="react-select-container"
        classNamePrefix="react-select-container"
        fullwidth
        placeholder={placeholder}
        value={value}
        options={options}
        isDisabled={disabled}
        isClearable
        onChange={onChange}
        isMulti={isMulti}
      />
    </React.Fragment>
  );
};

CallTypeSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  codes: PropTypes.array,
  actions: PropTypes.object,
  isMulti: PropTypes.bool,
  loading: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool
};

CallTypeSelect.defaultProps = {
  placeholder: "Call Type",
  disabled: false
};

function mapStatesToProps(state) {
  return {
    codes: state.reducers.codes,
    loading: state.reducers.loader?.loading || false
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...codeActions,
        ...loaderActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(CallTypeSelect);
